"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStatusActions = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useUpdateWorkflow_1 = require("../hooks/useUpdateWorkflow");
const useRevertWorkflow_1 = require("../hooks/useRevertWorkflow");
const WorkflowStatusActions = props => {
    const { workflow, onChange } = props;
    const { id, name, status, version } = workflow;
    const onChangeRef = (0, react_1.useRef)(onChange);
    const [openRevertDialog, setOpenRevertDialog] = (0, react_1.useState)(false);
    const [openSignatureDialog, setOpenSignatureDialog] = (0, react_1.useState)(false);
    const { data: updatedWorkflow, updateWorkflow } = (0, useUpdateWorkflow_1.useUpdateWorkflow)(id);
    const { workflow: revertedWorkflow, revert } = (0, useRevertWorkflow_1.useRevertWorkflow)(id);
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedWorkflow) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedWorkflow);
        }
    }, [updatedWorkflow]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (revertedWorkflow) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, revertedWorkflow);
        }
    }, [revertedWorkflow]);
    if (!status) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    else if (status === workflow_core_1.WorkflowStatus.Published) {
        return (react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', onClick: () => updateWorkflow({ status: workflow_core_1.WorkflowStatus.Draft }) }, "Start New Version"));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        version > 1 && (react_1.default.createElement(core_1.Button, { color: 'secondary', variant: 'outlined', onClick: () => setOpenRevertDialog(true) }, "Revert to Previous Version")),
        react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', onClick: () => setOpenSignatureDialog(true) }, "Publish"),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openRevertDialog, title: `Revert to version: ${version - 1}`, message: `Are you sure you want to erase any changes in ${name} version: ${version} and rollback to version: ${version - 1}? You will not be able to undo this change.`, onCancel: () => setOpenRevertDialog(false), onConfirm: () => {
                setOpenRevertDialog(false);
                revert();
            } }),
        react_1.default.createElement(user_ui_1.ElectronicSignatureDialog, { open: openSignatureDialog, meaning: 'Sign and approve workflow.', onCancel: () => setOpenSignatureDialog(false), onSigned: () => {
                setOpenSignatureDialog(false);
                updateWorkflow({ status: workflow_core_1.WorkflowStatus.Published });
            } })));
};
exports.WorkflowStatusActions = WorkflowStatusActions;
exports.default = exports.WorkflowStatusActions;
//# sourceMappingURL=WorkflowStatusActions.js.map